import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import Translator from './../../requests/apa/Translator';

export class EmptyContent extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  };

  static defaultProps = {
    title: '',
    message: '',
  };

  render() {
    const { title, message } = this.props;
    return (
      <div className="ribbon-root">
        <div className="ribbon-title">{title}</div>
        <div className="no-elements focusable">
          <span>{message}</span>
        </div>
      </div>
    )
  }
}

export default class MyRecordings extends PureComponent {
  static propTypes = {
    render: PropTypes.func.isRequired,
    showTimeUsedBar: PropTypes.bool
  };

  static defaultProps = {
    render: () => null,
    showTimeUsedBar: true
  };

  state = {
    limit: 0,
    used: 0,
  };

  componentDidUpdate(){
    window.SpatialNavigation.focus('.ribbon-items .focusable');
  }

  updateNpvrStorageUsed = ({limit, used}) => {
    // used esta en segundos, proviene de recordingList
    //limit esta en minutos, viene de linealChannels
    used = Math.floor(used / 60);

    const free = limit - used;
    const limitHours = Math.floor(limit / 60);
    const freeHours = Math.floor(free / 60);
    const freeMin = free % 60;

    let tag_first = Translator.get('recording_tag_first', 'Disponible');
    let tag_hours = Translator.get('recording_tag_h', 'Horas');
    let tag_mins = Translator.get('recording_tag_m', 'Minutos');
    let tag_join = Translator.get('recording_tag_join', 'de');
    let tagMins = !freeMin == 0 ? freeMin + ' ' + tag_mins : '';

    let tag_end =
        tag_first +
        ' ' +
        freeHours +
        ' ' +
        tag_hours +
        ' ' +
        tagMins +
        ' ' +
        tag_join +
        ' ' +
        limitHours +
        ' ' +
        tag_hours +
        '.';
    let usedPerc = limit !== 0 ? (used / limit) * 100 : 0;

    if(this.refs['tag']) {
      this.refs['tag'].innerHTML = tag_end;
    }
    if(this.refs['bar1']) {
      this.refs['bar1'].style.width = usedPerc + '%';
    }
  };

  render() {
    const { showTimeUsedBar } = this.props;
    return (
      <div id="myRecords" className="my-records-wrapper">
        { showTimeUsedBar && 
          <div className="time-recorded-wrapper">
            <div ref="tag" className="time-recorded-label"></div>
            <div className="time-recorded">
              <div ref="bar1" className="time-recorded-used" />
            </div>
          </div> 
        }
        {this.props.render(this.updateNpvrStorageUsed)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MyContent/MyRecordings.jsx